"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VEHICLE_MAKE;
(function (VEHICLE_MAKE) {
    VEHICLE_MAKE["FREIGHTLINER"] = "Freightliner";
    VEHICLE_MAKE["WESTERN_STAR"] = "WesternStar";
})(VEHICLE_MAKE || (VEHICLE_MAKE = {}));
exports.default = VEHICLE_MAKE;
